// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: odoo/integrations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { IntegrationApp } from "../integrationapp";

export const protobufPackage = "pc.proto.odoo.integrations";

export enum Access {
  ACCESS_UNKNOWN = 0,
  ACCESS_PRIVATE = 1,
  ACCESS_PUBLIC = 2,
  UNRECOGNIZED = -1,
}

export function accessFromJSON(object: any): Access {
  switch (object) {
    case 0:
    case "ACCESS_UNKNOWN":
      return Access.ACCESS_UNKNOWN;
    case 1:
    case "ACCESS_PRIVATE":
      return Access.ACCESS_PRIVATE;
    case 2:
    case "ACCESS_PUBLIC":
      return Access.ACCESS_PUBLIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Access.UNRECOGNIZED;
  }
}

export function accessToJSON(object: Access): string {
  switch (object) {
    case Access.ACCESS_UNKNOWN:
      return "ACCESS_UNKNOWN";
    case Access.ACCESS_PRIVATE:
      return "ACCESS_PRIVATE";
    case Access.ACCESS_PUBLIC:
      return "ACCESS_PUBLIC";
    case Access.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MarketplaceVisibility {
  MARKETPLACEVISIBILITY_UNKNOWN = 0,
  MARKETPLACEVISIBILITY_INVISIBLE = 1,
  MARKETPLACEVISIBILITY_VISIBLE = 2,
  UNRECOGNIZED = -1,
}

export function marketplaceVisibilityFromJSON(object: any): MarketplaceVisibility {
  switch (object) {
    case 0:
    case "MARKETPLACEVISIBILITY_UNKNOWN":
      return MarketplaceVisibility.MARKETPLACEVISIBILITY_UNKNOWN;
    case 1:
    case "MARKETPLACEVISIBILITY_INVISIBLE":
      return MarketplaceVisibility.MARKETPLACEVISIBILITY_INVISIBLE;
    case 2:
    case "MARKETPLACEVISIBILITY_VISIBLE":
      return MarketplaceVisibility.MARKETPLACEVISIBILITY_VISIBLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MarketplaceVisibility.UNRECOGNIZED;
  }
}

export function marketplaceVisibilityToJSON(object: MarketplaceVisibility): string {
  switch (object) {
    case MarketplaceVisibility.MARKETPLACEVISIBILITY_UNKNOWN:
      return "MARKETPLACEVISIBILITY_UNKNOWN";
    case MarketplaceVisibility.MARKETPLACEVISIBILITY_INVISIBLE:
      return "MARKETPLACEVISIBILITY_INVISIBLE";
    case MarketplaceVisibility.MARKETPLACEVISIBILITY_VISIBLE:
      return "MARKETPLACEVISIBILITY_VISIBLE";
    case MarketplaceVisibility.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Used to display the list in the marketplace. Does not contain detail information, e.g. resources */
export interface SlimIntegrationApp {
  uuid: string;
  /** Name, given by the partner */
  name: string;
  access: Access;
  marketplaceVisibility: MarketplaceVisibility;
  /** Vendor of the Integration app (e.g. SuperCRM) */
  vendor: string;
  description: string;
  /** Highest version of this integration app */
  currentVersion: number;
  documentationUrl: string;
  websiteUrl: string;
  supportEmail: string;
  privacyPolicyUrl: string;
  iconUrl: string;
}

/** Response object used to pass all objects visible */
export interface GetIntegrationAppListResponse {
  outcome: GetIntegrationAppListResponse_Outcome;
  apps: SlimIntegrationApp[];
}

export enum GetIntegrationAppListResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function getIntegrationAppListResponse_OutcomeFromJSON(object: any): GetIntegrationAppListResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return GetIntegrationAppListResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return GetIntegrationAppListResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return GetIntegrationAppListResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetIntegrationAppListResponse_Outcome.UNRECOGNIZED;
  }
}

export function getIntegrationAppListResponse_OutcomeToJSON(object: GetIntegrationAppListResponse_Outcome): string {
  switch (object) {
    case GetIntegrationAppListResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case GetIntegrationAppListResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case GetIntegrationAppListResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case GetIntegrationAppListResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IntegrationAppOwner {
  /** id of the res.partner object (company), owning this app */
  ownerId: number;
}

/** Used to pass detailed information about a certain integration app */
export interface GetIntegrationAppDetailsResponse {
  outcome: GetIntegrationAppDetailsResponse_Outcome;
  app?: IntegrationApp | undefined;
  appVersion: number;
  access: Access;
  marketplaceVisibility: MarketplaceVisibility;
  appOwner?: IntegrationAppOwner | undefined;
}

export enum GetIntegrationAppDetailsResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function getIntegrationAppDetailsResponse_OutcomeFromJSON(
  object: any,
): GetIntegrationAppDetailsResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return GetIntegrationAppDetailsResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return GetIntegrationAppDetailsResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return GetIntegrationAppDetailsResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetIntegrationAppDetailsResponse_Outcome.UNRECOGNIZED;
  }
}

export function getIntegrationAppDetailsResponse_OutcomeToJSON(
  object: GetIntegrationAppDetailsResponse_Outcome,
): string {
  switch (object) {
    case GetIntegrationAppDetailsResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case GetIntegrationAppDetailsResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case GetIntegrationAppDetailsResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case GetIntegrationAppDetailsResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Request used to install an integration app. Contains a reference to the integration app to be installed */
export interface InstallPbxIntegrationAppRequest {
  applianceId: number;
  integrationAppUuid: string;
  integrationAppVersion: number;
  /** later: pc.proto.integrationapp.IntegrationAppInstallationParameters */
  apiKeys: InstallPbxIntegrationAppRequest_ApiKey[];
}

export interface InstallPbxIntegrationAppRequest_ApiKey {
  /** must match one identifier in the the ApiPermissions object of the app being installed */
  identifier: string;
  /** e.g. "sha256:tMmiiTI7IaAcPpQPFQ65uMVCWH8av9jw4cwf/F5HVRQ=" */
  secretHash: string;
}

export interface InstallPbxIntegrationAppResponse {
  outcome: InstallPbxIntegrationAppResponse_Outcome;
}

export enum InstallPbxIntegrationAppResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function installPbxIntegrationAppResponse_OutcomeFromJSON(
  object: any,
): InstallPbxIntegrationAppResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return InstallPbxIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return InstallPbxIntegrationAppResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return InstallPbxIntegrationAppResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InstallPbxIntegrationAppResponse_Outcome.UNRECOGNIZED;
  }
}

export function installPbxIntegrationAppResponse_OutcomeToJSON(
  object: InstallPbxIntegrationAppResponse_Outcome,
): string {
  switch (object) {
    case InstallPbxIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case InstallPbxIntegrationAppResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case InstallPbxIntegrationAppResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case InstallPbxIntegrationAppResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Request used to uninstall an integration app. Contains a reference to the integration app to be uninstalled */
export interface UninstallPbxIntegrationAppRequest {
  applianceId: number;
  integrationAppUuid: string;
}

export interface UninstallPbxIntegrationAppResponse {
  outcome: UninstallPbxIntegrationAppResponse_Outcome;
}

export enum UninstallPbxIntegrationAppResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function uninstallPbxIntegrationAppResponse_OutcomeFromJSON(
  object: any,
): UninstallPbxIntegrationAppResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return UninstallPbxIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return UninstallPbxIntegrationAppResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return UninstallPbxIntegrationAppResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UninstallPbxIntegrationAppResponse_Outcome.UNRECOGNIZED;
  }
}

export function uninstallPbxIntegrationAppResponse_OutcomeToJSON(
  object: UninstallPbxIntegrationAppResponse_Outcome,
): string {
  switch (object) {
    case UninstallPbxIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case UninstallPbxIntegrationAppResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case UninstallPbxIntegrationAppResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case UninstallPbxIntegrationAppResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CreateIntegrationAppRequest {
  request?: { $case: "pbxIntegrationApp"; pbxIntegrationApp: CreatePbxIntegrationAppRequest } | undefined;
}

export interface CreatePbxIntegrationAppRequest {
  integrationApp?: IntegrationApp | undefined;
}

export interface CreateIntegrationAppResponse {
  outcome: CreateIntegrationAppResponse_Outcome;
  uuid: string;
}

export enum CreateIntegrationAppResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function createIntegrationAppResponse_OutcomeFromJSON(object: any): CreateIntegrationAppResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return CreateIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return CreateIntegrationAppResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return CreateIntegrationAppResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CreateIntegrationAppResponse_Outcome.UNRECOGNIZED;
  }
}

export function createIntegrationAppResponse_OutcomeToJSON(object: CreateIntegrationAppResponse_Outcome): string {
  switch (object) {
    case CreateIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case CreateIntegrationAppResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case CreateIntegrationAppResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case CreateIntegrationAppResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface UpgradeIntegrationAppRequest {
  request?: { $case: "pbxIntegrationApp"; pbxIntegrationApp: UpgradePbxIntegrationAppRequest } | undefined;
}

export interface UpgradePbxIntegrationAppRequest {
  integrationApp?: IntegrationApp | undefined;
}

export interface UpgradeIntegrationAppResponse {
  outcome: UpgradeIntegrationAppResponse_Outcome;
  version: number;
}

export enum UpgradeIntegrationAppResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_ERROR = 2,
  UNRECOGNIZED = -1,
}

export function upgradeIntegrationAppResponse_OutcomeFromJSON(object: any): UpgradeIntegrationAppResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return UpgradeIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return UpgradeIntegrationAppResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_ERROR":
      return UpgradeIntegrationAppResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UpgradeIntegrationAppResponse_Outcome.UNRECOGNIZED;
  }
}

export function upgradeIntegrationAppResponse_OutcomeToJSON(object: UpgradeIntegrationAppResponse_Outcome): string {
  switch (object) {
    case UpgradeIntegrationAppResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case UpgradeIntegrationAppResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case UpgradeIntegrationAppResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case UpgradeIntegrationAppResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IntegrationAppInstallation {
  app?: SlimIntegrationApp | undefined;
  state: IntegrationAppInstallation_State;
  /** string progress_message = 3; //err_app_resource_already_exists */
  installedVersion: number;
}

export enum IntegrationAppInstallation_State {
  STATE_UNKNOWN = 0,
  STATE_INSTALL_STARTED = 1,
  STATE_INSTALL_PROGRESS = 2,
  STATE_INSTALLED = 3,
  STATE_INSTALL_FAILED = 4,
  STATE_UNINSTALL_STARTED = 5,
  STATE_UNINSTALL_PROGRESS = 6,
  STATE_UNINSTALLED = 7,
  STATE_UNINSTALL_FAILED = 8,
  UNRECOGNIZED = -1,
}

export function integrationAppInstallation_StateFromJSON(object: any): IntegrationAppInstallation_State {
  switch (object) {
    case 0:
    case "STATE_UNKNOWN":
      return IntegrationAppInstallation_State.STATE_UNKNOWN;
    case 1:
    case "STATE_INSTALL_STARTED":
      return IntegrationAppInstallation_State.STATE_INSTALL_STARTED;
    case 2:
    case "STATE_INSTALL_PROGRESS":
      return IntegrationAppInstallation_State.STATE_INSTALL_PROGRESS;
    case 3:
    case "STATE_INSTALLED":
      return IntegrationAppInstallation_State.STATE_INSTALLED;
    case 4:
    case "STATE_INSTALL_FAILED":
      return IntegrationAppInstallation_State.STATE_INSTALL_FAILED;
    case 5:
    case "STATE_UNINSTALL_STARTED":
      return IntegrationAppInstallation_State.STATE_UNINSTALL_STARTED;
    case 6:
    case "STATE_UNINSTALL_PROGRESS":
      return IntegrationAppInstallation_State.STATE_UNINSTALL_PROGRESS;
    case 7:
    case "STATE_UNINSTALLED":
      return IntegrationAppInstallation_State.STATE_UNINSTALLED;
    case 8:
    case "STATE_UNINSTALL_FAILED":
      return IntegrationAppInstallation_State.STATE_UNINSTALL_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IntegrationAppInstallation_State.UNRECOGNIZED;
  }
}

export function integrationAppInstallation_StateToJSON(object: IntegrationAppInstallation_State): string {
  switch (object) {
    case IntegrationAppInstallation_State.STATE_UNKNOWN:
      return "STATE_UNKNOWN";
    case IntegrationAppInstallation_State.STATE_INSTALL_STARTED:
      return "STATE_INSTALL_STARTED";
    case IntegrationAppInstallation_State.STATE_INSTALL_PROGRESS:
      return "STATE_INSTALL_PROGRESS";
    case IntegrationAppInstallation_State.STATE_INSTALLED:
      return "STATE_INSTALLED";
    case IntegrationAppInstallation_State.STATE_INSTALL_FAILED:
      return "STATE_INSTALL_FAILED";
    case IntegrationAppInstallation_State.STATE_UNINSTALL_STARTED:
      return "STATE_UNINSTALL_STARTED";
    case IntegrationAppInstallation_State.STATE_UNINSTALL_PROGRESS:
      return "STATE_UNINSTALL_PROGRESS";
    case IntegrationAppInstallation_State.STATE_UNINSTALLED:
      return "STATE_UNINSTALLED";
    case IntegrationAppInstallation_State.STATE_UNINSTALL_FAILED:
      return "STATE_UNINSTALL_FAILED";
    case IntegrationAppInstallation_State.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PbxIntegrationAppInstallation {
  applianceId: number;
  installation?: IntegrationAppInstallation | undefined;
}

export interface GetPbxIntegrationAppInstallationsRequest {
  /** optional: Return all installations, which are related to a certain app */
  appUuid: string;
  /** optional: Return all installations, which are related to a certain appliance */
  applianceId: number;
}

export interface GetPbxIntegrationAppInstallationsResponse {
  outcome: GetPbxIntegrationAppInstallationsResponse_Outcome;
  installations: PbxIntegrationAppInstallation[];
}

export enum GetPbxIntegrationAppInstallationsResponse_Outcome {
  OUTCOME_UNKNOWN = 0,
  OUTCOME_SUCCESS = 1,
  OUTCOME_APPLIANCE_NOT_FOUND = 2,
  OUTCOME_APP_NOT_FOUND = 3,
  OUTCOME_ERROR = 4,
  UNRECOGNIZED = -1,
}

export function getPbxIntegrationAppInstallationsResponse_OutcomeFromJSON(
  object: any,
): GetPbxIntegrationAppInstallationsResponse_Outcome {
  switch (object) {
    case 0:
    case "OUTCOME_UNKNOWN":
      return GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_UNKNOWN;
    case 1:
    case "OUTCOME_SUCCESS":
      return GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_SUCCESS;
    case 2:
    case "OUTCOME_APPLIANCE_NOT_FOUND":
      return GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_APPLIANCE_NOT_FOUND;
    case 3:
    case "OUTCOME_APP_NOT_FOUND":
      return GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_APP_NOT_FOUND;
    case 4:
    case "OUTCOME_ERROR":
      return GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GetPbxIntegrationAppInstallationsResponse_Outcome.UNRECOGNIZED;
  }
}

export function getPbxIntegrationAppInstallationsResponse_OutcomeToJSON(
  object: GetPbxIntegrationAppInstallationsResponse_Outcome,
): string {
  switch (object) {
    case GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_UNKNOWN:
      return "OUTCOME_UNKNOWN";
    case GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_SUCCESS:
      return "OUTCOME_SUCCESS";
    case GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_APPLIANCE_NOT_FOUND:
      return "OUTCOME_APPLIANCE_NOT_FOUND";
    case GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_APP_NOT_FOUND:
      return "OUTCOME_APP_NOT_FOUND";
    case GetPbxIntegrationAppInstallationsResponse_Outcome.OUTCOME_ERROR:
      return "OUTCOME_ERROR";
    case GetPbxIntegrationAppInstallationsResponse_Outcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSlimIntegrationApp(): SlimIntegrationApp {
  return {
    uuid: "",
    name: "",
    access: 0,
    marketplaceVisibility: 0,
    vendor: "",
    description: "",
    currentVersion: 0,
    documentationUrl: "",
    websiteUrl: "",
    supportEmail: "",
    privacyPolicyUrl: "",
    iconUrl: "",
  };
}

export const SlimIntegrationApp: MessageFns<SlimIntegrationApp> = {
  encode(message: SlimIntegrationApp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.access !== 0) {
      writer.uint32(24).int32(message.access);
    }
    if (message.marketplaceVisibility !== 0) {
      writer.uint32(32).int32(message.marketplaceVisibility);
    }
    if (message.vendor !== "") {
      writer.uint32(42).string(message.vendor);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.currentVersion !== 0) {
      writer.uint32(56).uint64(message.currentVersion);
    }
    if (message.documentationUrl !== "") {
      writer.uint32(66).string(message.documentationUrl);
    }
    if (message.websiteUrl !== "") {
      writer.uint32(74).string(message.websiteUrl);
    }
    if (message.supportEmail !== "") {
      writer.uint32(82).string(message.supportEmail);
    }
    if (message.privacyPolicyUrl !== "") {
      writer.uint32(90).string(message.privacyPolicyUrl);
    }
    if (message.iconUrl !== "") {
      writer.uint32(98).string(message.iconUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlimIntegrationApp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlimIntegrationApp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.access = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.marketplaceVisibility = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.vendor = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.currentVersion = longToNumber(reader.uint64());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.documentationUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.websiteUrl = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.supportEmail = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.privacyPolicyUrl = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.iconUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlimIntegrationApp {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      access: isSet(object.access) ? accessFromJSON(object.access) : 0,
      marketplaceVisibility: isSet(object.marketplaceVisibility)
        ? marketplaceVisibilityFromJSON(object.marketplaceVisibility)
        : 0,
      vendor: isSet(object.vendor) ? globalThis.String(object.vendor) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      currentVersion: isSet(object.currentVersion) ? globalThis.Number(object.currentVersion) : 0,
      documentationUrl: isSet(object.documentationUrl) ? globalThis.String(object.documentationUrl) : "",
      websiteUrl: isSet(object.websiteUrl) ? globalThis.String(object.websiteUrl) : "",
      supportEmail: isSet(object.supportEmail) ? globalThis.String(object.supportEmail) : "",
      privacyPolicyUrl: isSet(object.privacyPolicyUrl) ? globalThis.String(object.privacyPolicyUrl) : "",
      iconUrl: isSet(object.iconUrl) ? globalThis.String(object.iconUrl) : "",
    };
  },

  toJSON(message: SlimIntegrationApp): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.access !== 0) {
      obj.access = accessToJSON(message.access);
    }
    if (message.marketplaceVisibility !== 0) {
      obj.marketplaceVisibility = marketplaceVisibilityToJSON(message.marketplaceVisibility);
    }
    if (message.vendor !== "") {
      obj.vendor = message.vendor;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.currentVersion !== 0) {
      obj.currentVersion = Math.round(message.currentVersion);
    }
    if (message.documentationUrl !== "") {
      obj.documentationUrl = message.documentationUrl;
    }
    if (message.websiteUrl !== "") {
      obj.websiteUrl = message.websiteUrl;
    }
    if (message.supportEmail !== "") {
      obj.supportEmail = message.supportEmail;
    }
    if (message.privacyPolicyUrl !== "") {
      obj.privacyPolicyUrl = message.privacyPolicyUrl;
    }
    if (message.iconUrl !== "") {
      obj.iconUrl = message.iconUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SlimIntegrationApp>, I>>(base?: I): SlimIntegrationApp {
    return SlimIntegrationApp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SlimIntegrationApp>, I>>(object: I): SlimIntegrationApp {
    const message = createBaseSlimIntegrationApp();
    message.uuid = object.uuid ?? "";
    message.name = object.name ?? "";
    message.access = object.access ?? 0;
    message.marketplaceVisibility = object.marketplaceVisibility ?? 0;
    message.vendor = object.vendor ?? "";
    message.description = object.description ?? "";
    message.currentVersion = object.currentVersion ?? 0;
    message.documentationUrl = object.documentationUrl ?? "";
    message.websiteUrl = object.websiteUrl ?? "";
    message.supportEmail = object.supportEmail ?? "";
    message.privacyPolicyUrl = object.privacyPolicyUrl ?? "";
    message.iconUrl = object.iconUrl ?? "";
    return message;
  },
};

function createBaseGetIntegrationAppListResponse(): GetIntegrationAppListResponse {
  return { outcome: 0, apps: [] };
}

export const GetIntegrationAppListResponse: MessageFns<GetIntegrationAppListResponse> = {
  encode(message: GetIntegrationAppListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    for (const v of message.apps) {
      SlimIntegrationApp.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIntegrationAppListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIntegrationAppListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.apps.push(SlimIntegrationApp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIntegrationAppListResponse {
    return {
      outcome: isSet(object.outcome) ? getIntegrationAppListResponse_OutcomeFromJSON(object.outcome) : 0,
      apps: globalThis.Array.isArray(object?.apps) ? object.apps.map((e: any) => SlimIntegrationApp.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetIntegrationAppListResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = getIntegrationAppListResponse_OutcomeToJSON(message.outcome);
    }
    if (message.apps?.length) {
      obj.apps = message.apps.map((e) => SlimIntegrationApp.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetIntegrationAppListResponse>, I>>(base?: I): GetIntegrationAppListResponse {
    return GetIntegrationAppListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetIntegrationAppListResponse>, I>>(
    object: I,
  ): GetIntegrationAppListResponse {
    const message = createBaseGetIntegrationAppListResponse();
    message.outcome = object.outcome ?? 0;
    message.apps = object.apps?.map((e) => SlimIntegrationApp.fromPartial(e)) || [];
    return message;
  },
};

function createBaseIntegrationAppOwner(): IntegrationAppOwner {
  return { ownerId: 0 };
}

export const IntegrationAppOwner: MessageFns<IntegrationAppOwner> = {
  encode(message: IntegrationAppOwner, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownerId !== 0) {
      writer.uint32(8).uint64(message.ownerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationAppOwner {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationAppOwner();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.ownerId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationAppOwner {
    return { ownerId: isSet(object.ownerId) ? globalThis.Number(object.ownerId) : 0 };
  },

  toJSON(message: IntegrationAppOwner): unknown {
    const obj: any = {};
    if (message.ownerId !== 0) {
      obj.ownerId = Math.round(message.ownerId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntegrationAppOwner>, I>>(base?: I): IntegrationAppOwner {
    return IntegrationAppOwner.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationAppOwner>, I>>(object: I): IntegrationAppOwner {
    const message = createBaseIntegrationAppOwner();
    message.ownerId = object.ownerId ?? 0;
    return message;
  },
};

function createBaseGetIntegrationAppDetailsResponse(): GetIntegrationAppDetailsResponse {
  return { outcome: 0, app: undefined, appVersion: 0, access: 0, marketplaceVisibility: 0, appOwner: undefined };
}

export const GetIntegrationAppDetailsResponse: MessageFns<GetIntegrationAppDetailsResponse> = {
  encode(message: GetIntegrationAppDetailsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.app !== undefined) {
      IntegrationApp.encode(message.app, writer.uint32(18).fork()).join();
    }
    if (message.appVersion !== 0) {
      writer.uint32(24).uint64(message.appVersion);
    }
    if (message.access !== 0) {
      writer.uint32(32).int32(message.access);
    }
    if (message.marketplaceVisibility !== 0) {
      writer.uint32(40).int32(message.marketplaceVisibility);
    }
    if (message.appOwner !== undefined) {
      IntegrationAppOwner.encode(message.appOwner, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIntegrationAppDetailsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIntegrationAppDetailsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.app = IntegrationApp.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.appVersion = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.access = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.marketplaceVisibility = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.appOwner = IntegrationAppOwner.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIntegrationAppDetailsResponse {
    return {
      outcome: isSet(object.outcome) ? getIntegrationAppDetailsResponse_OutcomeFromJSON(object.outcome) : 0,
      app: isSet(object.app) ? IntegrationApp.fromJSON(object.app) : undefined,
      appVersion: isSet(object.appVersion) ? globalThis.Number(object.appVersion) : 0,
      access: isSet(object.access) ? accessFromJSON(object.access) : 0,
      marketplaceVisibility: isSet(object.marketplaceVisibility)
        ? marketplaceVisibilityFromJSON(object.marketplaceVisibility)
        : 0,
      appOwner: isSet(object.appOwner) ? IntegrationAppOwner.fromJSON(object.appOwner) : undefined,
    };
  },

  toJSON(message: GetIntegrationAppDetailsResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = getIntegrationAppDetailsResponse_OutcomeToJSON(message.outcome);
    }
    if (message.app !== undefined) {
      obj.app = IntegrationApp.toJSON(message.app);
    }
    if (message.appVersion !== 0) {
      obj.appVersion = Math.round(message.appVersion);
    }
    if (message.access !== 0) {
      obj.access = accessToJSON(message.access);
    }
    if (message.marketplaceVisibility !== 0) {
      obj.marketplaceVisibility = marketplaceVisibilityToJSON(message.marketplaceVisibility);
    }
    if (message.appOwner !== undefined) {
      obj.appOwner = IntegrationAppOwner.toJSON(message.appOwner);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetIntegrationAppDetailsResponse>, I>>(
    base?: I,
  ): GetIntegrationAppDetailsResponse {
    return GetIntegrationAppDetailsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetIntegrationAppDetailsResponse>, I>>(
    object: I,
  ): GetIntegrationAppDetailsResponse {
    const message = createBaseGetIntegrationAppDetailsResponse();
    message.outcome = object.outcome ?? 0;
    message.app = (object.app !== undefined && object.app !== null)
      ? IntegrationApp.fromPartial(object.app)
      : undefined;
    message.appVersion = object.appVersion ?? 0;
    message.access = object.access ?? 0;
    message.marketplaceVisibility = object.marketplaceVisibility ?? 0;
    message.appOwner = (object.appOwner !== undefined && object.appOwner !== null)
      ? IntegrationAppOwner.fromPartial(object.appOwner)
      : undefined;
    return message;
  },
};

function createBaseInstallPbxIntegrationAppRequest(): InstallPbxIntegrationAppRequest {
  return { applianceId: 0, integrationAppUuid: "", integrationAppVersion: 0, apiKeys: [] };
}

export const InstallPbxIntegrationAppRequest: MessageFns<InstallPbxIntegrationAppRequest> = {
  encode(message: InstallPbxIntegrationAppRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.applianceId !== 0) {
      writer.uint32(8).uint64(message.applianceId);
    }
    if (message.integrationAppUuid !== "") {
      writer.uint32(18).string(message.integrationAppUuid);
    }
    if (message.integrationAppVersion !== 0) {
      writer.uint32(24).uint64(message.integrationAppVersion);
    }
    for (const v of message.apiKeys) {
      InstallPbxIntegrationAppRequest_ApiKey.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstallPbxIntegrationAppRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstallPbxIntegrationAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.integrationAppUuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.integrationAppVersion = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.apiKeys.push(InstallPbxIntegrationAppRequest_ApiKey.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InstallPbxIntegrationAppRequest {
    return {
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      integrationAppUuid: isSet(object.integrationAppUuid) ? globalThis.String(object.integrationAppUuid) : "",
      integrationAppVersion: isSet(object.integrationAppVersion) ? globalThis.Number(object.integrationAppVersion) : 0,
      apiKeys: globalThis.Array.isArray(object?.apiKeys)
        ? object.apiKeys.map((e: any) => InstallPbxIntegrationAppRequest_ApiKey.fromJSON(e))
        : [],
    };
  },

  toJSON(message: InstallPbxIntegrationAppRequest): unknown {
    const obj: any = {};
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.integrationAppUuid !== "") {
      obj.integrationAppUuid = message.integrationAppUuid;
    }
    if (message.integrationAppVersion !== 0) {
      obj.integrationAppVersion = Math.round(message.integrationAppVersion);
    }
    if (message.apiKeys?.length) {
      obj.apiKeys = message.apiKeys.map((e) => InstallPbxIntegrationAppRequest_ApiKey.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InstallPbxIntegrationAppRequest>, I>>(base?: I): InstallPbxIntegrationAppRequest {
    return InstallPbxIntegrationAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InstallPbxIntegrationAppRequest>, I>>(
    object: I,
  ): InstallPbxIntegrationAppRequest {
    const message = createBaseInstallPbxIntegrationAppRequest();
    message.applianceId = object.applianceId ?? 0;
    message.integrationAppUuid = object.integrationAppUuid ?? "";
    message.integrationAppVersion = object.integrationAppVersion ?? 0;
    message.apiKeys = object.apiKeys?.map((e) => InstallPbxIntegrationAppRequest_ApiKey.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInstallPbxIntegrationAppRequest_ApiKey(): InstallPbxIntegrationAppRequest_ApiKey {
  return { identifier: "", secretHash: "" };
}

export const InstallPbxIntegrationAppRequest_ApiKey: MessageFns<InstallPbxIntegrationAppRequest_ApiKey> = {
  encode(message: InstallPbxIntegrationAppRequest_ApiKey, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }
    if (message.secretHash !== "") {
      writer.uint32(18).string(message.secretHash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstallPbxIntegrationAppRequest_ApiKey {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstallPbxIntegrationAppRequest_ApiKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.secretHash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InstallPbxIntegrationAppRequest_ApiKey {
    return {
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
      secretHash: isSet(object.secretHash) ? globalThis.String(object.secretHash) : "",
    };
  },

  toJSON(message: InstallPbxIntegrationAppRequest_ApiKey): unknown {
    const obj: any = {};
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.secretHash !== "") {
      obj.secretHash = message.secretHash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InstallPbxIntegrationAppRequest_ApiKey>, I>>(
    base?: I,
  ): InstallPbxIntegrationAppRequest_ApiKey {
    return InstallPbxIntegrationAppRequest_ApiKey.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InstallPbxIntegrationAppRequest_ApiKey>, I>>(
    object: I,
  ): InstallPbxIntegrationAppRequest_ApiKey {
    const message = createBaseInstallPbxIntegrationAppRequest_ApiKey();
    message.identifier = object.identifier ?? "";
    message.secretHash = object.secretHash ?? "";
    return message;
  },
};

function createBaseInstallPbxIntegrationAppResponse(): InstallPbxIntegrationAppResponse {
  return { outcome: 0 };
}

export const InstallPbxIntegrationAppResponse: MessageFns<InstallPbxIntegrationAppResponse> = {
  encode(message: InstallPbxIntegrationAppResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstallPbxIntegrationAppResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInstallPbxIntegrationAppResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InstallPbxIntegrationAppResponse {
    return { outcome: isSet(object.outcome) ? installPbxIntegrationAppResponse_OutcomeFromJSON(object.outcome) : 0 };
  },

  toJSON(message: InstallPbxIntegrationAppResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = installPbxIntegrationAppResponse_OutcomeToJSON(message.outcome);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InstallPbxIntegrationAppResponse>, I>>(
    base?: I,
  ): InstallPbxIntegrationAppResponse {
    return InstallPbxIntegrationAppResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InstallPbxIntegrationAppResponse>, I>>(
    object: I,
  ): InstallPbxIntegrationAppResponse {
    const message = createBaseInstallPbxIntegrationAppResponse();
    message.outcome = object.outcome ?? 0;
    return message;
  },
};

function createBaseUninstallPbxIntegrationAppRequest(): UninstallPbxIntegrationAppRequest {
  return { applianceId: 0, integrationAppUuid: "" };
}

export const UninstallPbxIntegrationAppRequest: MessageFns<UninstallPbxIntegrationAppRequest> = {
  encode(message: UninstallPbxIntegrationAppRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.applianceId !== 0) {
      writer.uint32(8).uint64(message.applianceId);
    }
    if (message.integrationAppUuid !== "") {
      writer.uint32(18).string(message.integrationAppUuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UninstallPbxIntegrationAppRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUninstallPbxIntegrationAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.integrationAppUuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UninstallPbxIntegrationAppRequest {
    return {
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      integrationAppUuid: isSet(object.integrationAppUuid) ? globalThis.String(object.integrationAppUuid) : "",
    };
  },

  toJSON(message: UninstallPbxIntegrationAppRequest): unknown {
    const obj: any = {};
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.integrationAppUuid !== "") {
      obj.integrationAppUuid = message.integrationAppUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UninstallPbxIntegrationAppRequest>, I>>(
    base?: I,
  ): UninstallPbxIntegrationAppRequest {
    return UninstallPbxIntegrationAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UninstallPbxIntegrationAppRequest>, I>>(
    object: I,
  ): UninstallPbxIntegrationAppRequest {
    const message = createBaseUninstallPbxIntegrationAppRequest();
    message.applianceId = object.applianceId ?? 0;
    message.integrationAppUuid = object.integrationAppUuid ?? "";
    return message;
  },
};

function createBaseUninstallPbxIntegrationAppResponse(): UninstallPbxIntegrationAppResponse {
  return { outcome: 0 };
}

export const UninstallPbxIntegrationAppResponse: MessageFns<UninstallPbxIntegrationAppResponse> = {
  encode(message: UninstallPbxIntegrationAppResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UninstallPbxIntegrationAppResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUninstallPbxIntegrationAppResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UninstallPbxIntegrationAppResponse {
    return { outcome: isSet(object.outcome) ? uninstallPbxIntegrationAppResponse_OutcomeFromJSON(object.outcome) : 0 };
  },

  toJSON(message: UninstallPbxIntegrationAppResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = uninstallPbxIntegrationAppResponse_OutcomeToJSON(message.outcome);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UninstallPbxIntegrationAppResponse>, I>>(
    base?: I,
  ): UninstallPbxIntegrationAppResponse {
    return UninstallPbxIntegrationAppResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UninstallPbxIntegrationAppResponse>, I>>(
    object: I,
  ): UninstallPbxIntegrationAppResponse {
    const message = createBaseUninstallPbxIntegrationAppResponse();
    message.outcome = object.outcome ?? 0;
    return message;
  },
};

function createBaseCreateIntegrationAppRequest(): CreateIntegrationAppRequest {
  return { request: undefined };
}

export const CreateIntegrationAppRequest: MessageFns<CreateIntegrationAppRequest> = {
  encode(message: CreateIntegrationAppRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.request?.$case) {
      case "pbxIntegrationApp":
        CreatePbxIntegrationAppRequest.encode(message.request.pbxIntegrationApp, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateIntegrationAppRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateIntegrationAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request = {
            $case: "pbxIntegrationApp",
            pbxIntegrationApp: CreatePbxIntegrationAppRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateIntegrationAppRequest {
    return {
      request: isSet(object.pbxIntegrationApp)
        ? {
          $case: "pbxIntegrationApp",
          pbxIntegrationApp: CreatePbxIntegrationAppRequest.fromJSON(object.pbxIntegrationApp),
        }
        : undefined,
    };
  },

  toJSON(message: CreateIntegrationAppRequest): unknown {
    const obj: any = {};
    if (message.request?.$case === "pbxIntegrationApp") {
      obj.pbxIntegrationApp = CreatePbxIntegrationAppRequest.toJSON(message.request.pbxIntegrationApp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateIntegrationAppRequest>, I>>(base?: I): CreateIntegrationAppRequest {
    return CreateIntegrationAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateIntegrationAppRequest>, I>>(object: I): CreateIntegrationAppRequest {
    const message = createBaseCreateIntegrationAppRequest();
    switch (object.request?.$case) {
      case "pbxIntegrationApp": {
        if (object.request?.pbxIntegrationApp !== undefined && object.request?.pbxIntegrationApp !== null) {
          message.request = {
            $case: "pbxIntegrationApp",
            pbxIntegrationApp: CreatePbxIntegrationAppRequest.fromPartial(object.request.pbxIntegrationApp),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseCreatePbxIntegrationAppRequest(): CreatePbxIntegrationAppRequest {
  return { integrationApp: undefined };
}

export const CreatePbxIntegrationAppRequest: MessageFns<CreatePbxIntegrationAppRequest> = {
  encode(message: CreatePbxIntegrationAppRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.integrationApp !== undefined) {
      IntegrationApp.encode(message.integrationApp, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePbxIntegrationAppRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePbxIntegrationAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.integrationApp = IntegrationApp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePbxIntegrationAppRequest {
    return {
      integrationApp: isSet(object.integrationApp) ? IntegrationApp.fromJSON(object.integrationApp) : undefined,
    };
  },

  toJSON(message: CreatePbxIntegrationAppRequest): unknown {
    const obj: any = {};
    if (message.integrationApp !== undefined) {
      obj.integrationApp = IntegrationApp.toJSON(message.integrationApp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePbxIntegrationAppRequest>, I>>(base?: I): CreatePbxIntegrationAppRequest {
    return CreatePbxIntegrationAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePbxIntegrationAppRequest>, I>>(
    object: I,
  ): CreatePbxIntegrationAppRequest {
    const message = createBaseCreatePbxIntegrationAppRequest();
    message.integrationApp = (object.integrationApp !== undefined && object.integrationApp !== null)
      ? IntegrationApp.fromPartial(object.integrationApp)
      : undefined;
    return message;
  },
};

function createBaseCreateIntegrationAppResponse(): CreateIntegrationAppResponse {
  return { outcome: 0, uuid: "" };
}

export const CreateIntegrationAppResponse: MessageFns<CreateIntegrationAppResponse> = {
  encode(message: CreateIntegrationAppResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.uuid !== "") {
      writer.uint32(18).string(message.uuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateIntegrationAppResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateIntegrationAppResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateIntegrationAppResponse {
    return {
      outcome: isSet(object.outcome) ? createIntegrationAppResponse_OutcomeFromJSON(object.outcome) : 0,
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
    };
  },

  toJSON(message: CreateIntegrationAppResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = createIntegrationAppResponse_OutcomeToJSON(message.outcome);
    }
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateIntegrationAppResponse>, I>>(base?: I): CreateIntegrationAppResponse {
    return CreateIntegrationAppResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateIntegrationAppResponse>, I>>(object: I): CreateIntegrationAppResponse {
    const message = createBaseCreateIntegrationAppResponse();
    message.outcome = object.outcome ?? 0;
    message.uuid = object.uuid ?? "";
    return message;
  },
};

function createBaseUpgradeIntegrationAppRequest(): UpgradeIntegrationAppRequest {
  return { request: undefined };
}

export const UpgradeIntegrationAppRequest: MessageFns<UpgradeIntegrationAppRequest> = {
  encode(message: UpgradeIntegrationAppRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.request?.$case) {
      case "pbxIntegrationApp":
        UpgradePbxIntegrationAppRequest.encode(message.request.pbxIntegrationApp, writer.uint32(10).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpgradeIntegrationAppRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpgradeIntegrationAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.request = {
            $case: "pbxIntegrationApp",
            pbxIntegrationApp: UpgradePbxIntegrationAppRequest.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpgradeIntegrationAppRequest {
    return {
      request: isSet(object.pbxIntegrationApp)
        ? {
          $case: "pbxIntegrationApp",
          pbxIntegrationApp: UpgradePbxIntegrationAppRequest.fromJSON(object.pbxIntegrationApp),
        }
        : undefined,
    };
  },

  toJSON(message: UpgradeIntegrationAppRequest): unknown {
    const obj: any = {};
    if (message.request?.$case === "pbxIntegrationApp") {
      obj.pbxIntegrationApp = UpgradePbxIntegrationAppRequest.toJSON(message.request.pbxIntegrationApp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpgradeIntegrationAppRequest>, I>>(base?: I): UpgradeIntegrationAppRequest {
    return UpgradeIntegrationAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpgradeIntegrationAppRequest>, I>>(object: I): UpgradeIntegrationAppRequest {
    const message = createBaseUpgradeIntegrationAppRequest();
    switch (object.request?.$case) {
      case "pbxIntegrationApp": {
        if (object.request?.pbxIntegrationApp !== undefined && object.request?.pbxIntegrationApp !== null) {
          message.request = {
            $case: "pbxIntegrationApp",
            pbxIntegrationApp: UpgradePbxIntegrationAppRequest.fromPartial(object.request.pbxIntegrationApp),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseUpgradePbxIntegrationAppRequest(): UpgradePbxIntegrationAppRequest {
  return { integrationApp: undefined };
}

export const UpgradePbxIntegrationAppRequest: MessageFns<UpgradePbxIntegrationAppRequest> = {
  encode(message: UpgradePbxIntegrationAppRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.integrationApp !== undefined) {
      IntegrationApp.encode(message.integrationApp, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpgradePbxIntegrationAppRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpgradePbxIntegrationAppRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.integrationApp = IntegrationApp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpgradePbxIntegrationAppRequest {
    return {
      integrationApp: isSet(object.integrationApp) ? IntegrationApp.fromJSON(object.integrationApp) : undefined,
    };
  },

  toJSON(message: UpgradePbxIntegrationAppRequest): unknown {
    const obj: any = {};
    if (message.integrationApp !== undefined) {
      obj.integrationApp = IntegrationApp.toJSON(message.integrationApp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpgradePbxIntegrationAppRequest>, I>>(base?: I): UpgradePbxIntegrationAppRequest {
    return UpgradePbxIntegrationAppRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpgradePbxIntegrationAppRequest>, I>>(
    object: I,
  ): UpgradePbxIntegrationAppRequest {
    const message = createBaseUpgradePbxIntegrationAppRequest();
    message.integrationApp = (object.integrationApp !== undefined && object.integrationApp !== null)
      ? IntegrationApp.fromPartial(object.integrationApp)
      : undefined;
    return message;
  },
};

function createBaseUpgradeIntegrationAppResponse(): UpgradeIntegrationAppResponse {
  return { outcome: 0, version: 0 };
}

export const UpgradeIntegrationAppResponse: MessageFns<UpgradeIntegrationAppResponse> = {
  encode(message: UpgradeIntegrationAppResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.version !== 0) {
      writer.uint32(16).uint64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpgradeIntegrationAppResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpgradeIntegrationAppResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpgradeIntegrationAppResponse {
    return {
      outcome: isSet(object.outcome) ? upgradeIntegrationAppResponse_OutcomeFromJSON(object.outcome) : 0,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: UpgradeIntegrationAppResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = upgradeIntegrationAppResponse_OutcomeToJSON(message.outcome);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpgradeIntegrationAppResponse>, I>>(base?: I): UpgradeIntegrationAppResponse {
    return UpgradeIntegrationAppResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpgradeIntegrationAppResponse>, I>>(
    object: I,
  ): UpgradeIntegrationAppResponse {
    const message = createBaseUpgradeIntegrationAppResponse();
    message.outcome = object.outcome ?? 0;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseIntegrationAppInstallation(): IntegrationAppInstallation {
  return { app: undefined, state: 0, installedVersion: 0 };
}

export const IntegrationAppInstallation: MessageFns<IntegrationAppInstallation> = {
  encode(message: IntegrationAppInstallation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.app !== undefined) {
      SlimIntegrationApp.encode(message.app, writer.uint32(10).fork()).join();
    }
    if (message.state !== 0) {
      writer.uint32(16).int32(message.state);
    }
    if (message.installedVersion !== 0) {
      writer.uint32(24).uint64(message.installedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationAppInstallation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationAppInstallation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.app = SlimIntegrationApp.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.state = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.installedVersion = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationAppInstallation {
    return {
      app: isSet(object.app) ? SlimIntegrationApp.fromJSON(object.app) : undefined,
      state: isSet(object.state) ? integrationAppInstallation_StateFromJSON(object.state) : 0,
      installedVersion: isSet(object.installedVersion) ? globalThis.Number(object.installedVersion) : 0,
    };
  },

  toJSON(message: IntegrationAppInstallation): unknown {
    const obj: any = {};
    if (message.app !== undefined) {
      obj.app = SlimIntegrationApp.toJSON(message.app);
    }
    if (message.state !== 0) {
      obj.state = integrationAppInstallation_StateToJSON(message.state);
    }
    if (message.installedVersion !== 0) {
      obj.installedVersion = Math.round(message.installedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntegrationAppInstallation>, I>>(base?: I): IntegrationAppInstallation {
    return IntegrationAppInstallation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationAppInstallation>, I>>(object: I): IntegrationAppInstallation {
    const message = createBaseIntegrationAppInstallation();
    message.app = (object.app !== undefined && object.app !== null)
      ? SlimIntegrationApp.fromPartial(object.app)
      : undefined;
    message.state = object.state ?? 0;
    message.installedVersion = object.installedVersion ?? 0;
    return message;
  },
};

function createBasePbxIntegrationAppInstallation(): PbxIntegrationAppInstallation {
  return { applianceId: 0, installation: undefined };
}

export const PbxIntegrationAppInstallation: MessageFns<PbxIntegrationAppInstallation> = {
  encode(message: PbxIntegrationAppInstallation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.applianceId !== 0) {
      writer.uint32(8).uint64(message.applianceId);
    }
    if (message.installation !== undefined) {
      IntegrationAppInstallation.encode(message.installation, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PbxIntegrationAppInstallation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePbxIntegrationAppInstallation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.installation = IntegrationAppInstallation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PbxIntegrationAppInstallation {
    return {
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
      installation: isSet(object.installation) ? IntegrationAppInstallation.fromJSON(object.installation) : undefined,
    };
  },

  toJSON(message: PbxIntegrationAppInstallation): unknown {
    const obj: any = {};
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    if (message.installation !== undefined) {
      obj.installation = IntegrationAppInstallation.toJSON(message.installation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PbxIntegrationAppInstallation>, I>>(base?: I): PbxIntegrationAppInstallation {
    return PbxIntegrationAppInstallation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PbxIntegrationAppInstallation>, I>>(
    object: I,
  ): PbxIntegrationAppInstallation {
    const message = createBasePbxIntegrationAppInstallation();
    message.applianceId = object.applianceId ?? 0;
    message.installation = (object.installation !== undefined && object.installation !== null)
      ? IntegrationAppInstallation.fromPartial(object.installation)
      : undefined;
    return message;
  },
};

function createBaseGetPbxIntegrationAppInstallationsRequest(): GetPbxIntegrationAppInstallationsRequest {
  return { appUuid: "", applianceId: 0 };
}

export const GetPbxIntegrationAppInstallationsRequest: MessageFns<GetPbxIntegrationAppInstallationsRequest> = {
  encode(message: GetPbxIntegrationAppInstallationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.appUuid !== "") {
      writer.uint32(10).string(message.appUuid);
    }
    if (message.applianceId !== 0) {
      writer.uint32(16).uint64(message.applianceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPbxIntegrationAppInstallationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPbxIntegrationAppInstallationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.appUuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.applianceId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPbxIntegrationAppInstallationsRequest {
    return {
      appUuid: isSet(object.appUuid) ? globalThis.String(object.appUuid) : "",
      applianceId: isSet(object.applianceId) ? globalThis.Number(object.applianceId) : 0,
    };
  },

  toJSON(message: GetPbxIntegrationAppInstallationsRequest): unknown {
    const obj: any = {};
    if (message.appUuid !== "") {
      obj.appUuid = message.appUuid;
    }
    if (message.applianceId !== 0) {
      obj.applianceId = Math.round(message.applianceId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPbxIntegrationAppInstallationsRequest>, I>>(
    base?: I,
  ): GetPbxIntegrationAppInstallationsRequest {
    return GetPbxIntegrationAppInstallationsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPbxIntegrationAppInstallationsRequest>, I>>(
    object: I,
  ): GetPbxIntegrationAppInstallationsRequest {
    const message = createBaseGetPbxIntegrationAppInstallationsRequest();
    message.appUuid = object.appUuid ?? "";
    message.applianceId = object.applianceId ?? 0;
    return message;
  },
};

function createBaseGetPbxIntegrationAppInstallationsResponse(): GetPbxIntegrationAppInstallationsResponse {
  return { outcome: 0, installations: [] };
}

export const GetPbxIntegrationAppInstallationsResponse: MessageFns<GetPbxIntegrationAppInstallationsResponse> = {
  encode(message: GetPbxIntegrationAppInstallationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    for (const v of message.installations) {
      PbxIntegrationAppInstallation.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPbxIntegrationAppInstallationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPbxIntegrationAppInstallationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.outcome = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.installations.push(PbxIntegrationAppInstallation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPbxIntegrationAppInstallationsResponse {
    return {
      outcome: isSet(object.outcome) ? getPbxIntegrationAppInstallationsResponse_OutcomeFromJSON(object.outcome) : 0,
      installations: globalThis.Array.isArray(object?.installations)
        ? object.installations.map((e: any) => PbxIntegrationAppInstallation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPbxIntegrationAppInstallationsResponse): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = getPbxIntegrationAppInstallationsResponse_OutcomeToJSON(message.outcome);
    }
    if (message.installations?.length) {
      obj.installations = message.installations.map((e) => PbxIntegrationAppInstallation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPbxIntegrationAppInstallationsResponse>, I>>(
    base?: I,
  ): GetPbxIntegrationAppInstallationsResponse {
    return GetPbxIntegrationAppInstallationsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPbxIntegrationAppInstallationsResponse>, I>>(
    object: I,
  ): GetPbxIntegrationAppInstallationsResponse {
    const message = createBaseGetPbxIntegrationAppInstallationsResponse();
    message.outcome = object.outcome ?? 0;
    message.installations = object.installations?.map((e) => PbxIntegrationAppInstallation.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
